import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SolutionsHero from './components/SolutionsHero';
import WhyChooseUs from './components/WhyChooseUs';
import CapabilitiesDetail from './components/CapabilitiesDetail';
import IndustryBreakdown from './components/IndustryBreakdown';
import ComparisonTable from './components/ComparisonTable';
import PricingTransparency from './components/PricingTransparency';
import SolutionsCTA from './components/SolutionsCTA';
import SEO, { buildBreadcrumbSchema } from '@/components/SEO';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const solutionsSchema = [
  buildBreadcrumbSchema([
    { name: 'Home', href: '/' },
    { name: 'Solutions', href: '/solutions' },
  ]),
  {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Payment Solutions | Fore Capital',
  url: `${SITE_URL}/solutions`,
  description: 'Explore Fore Capital\'s payment solutions: omnichannel payments, gateway services, fraud prevention, POS integration, and developer APIs for retail, hospitality, and enterprise.',
  mainEntity: {
    '@type': 'Service',
    name: 'Payment Infrastructure Services',
    provider: {
      '@type': 'Organization',
      name: 'Fore Capital',
      url: SITE_URL,
    },
    areaServed: {
      '@type': 'Country',
      name: 'United States',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Payment Solutions',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Omnichannel Payments' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Payment Gateway' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Fraud Prevention' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'POS Integration' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Developer APIs' } },
      ],
    },
  },
  },
];

export default function Solutions() {
  return (
    <div className="min-h-screen bg-[#F9F9F7]" style={{ fontFamily: "'Google Sans Flex', sans-serif" }}>
      <SEO
        title="Payment Solutions | Fore Capital"
        description="Explore Fore Capital's payment solutions: omnichannel payments, gateway services, fraud prevention, POS integration, and developer APIs for retail, hospitality, and enterprise."
        keywords="payment solutions, omnichannel payments, payment gateway, fraud prevention, POS integration, developer APIs"
        pathname="/solutions"
        schema={solutionsSchema}
      />
      <Navbar />
      <main>
        <SolutionsHero />
        <WhyChooseUs />
        <CapabilitiesDetail />
        <IndustryBreakdown />
        <PricingTransparency />
        <ComparisonTable />
        <SolutionsCTA />
      </main>
      <Footer />
    </div>
  );
}